import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { values } from 'underscore';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import { Breadcrumb } from '@bingads-webui-react/breadcrumb';
import { SummaryBarContainer } from '@bingads-webui-react/summary-bar';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { SummaryBarBreadcrumb } from './index';
import { SummaryBarItemsResizeGroup } from './summary-bar-items-resize-group';

class SummaryBarFactory extends React.PureComponent {
  render() {
    const {
      backButtonProps,
      breadcrumbsProps,
      breadcrumbsGeneralConfigs,
      summaryBarItems,
      i18n,
      summaryBarActivityLogger,
      scope,
      siteMap,
      hideBreadcrumb,
      permissions,
    } = this.props;
    const summaryBarProps = {
      summaryBarItems,
      overflowAriaLabel: i18n.getString(_TL_('More options')),
      scope,
      siteMap,
    };

    let breadcrumb = null;
    if (breadcrumbsGeneralConfigs) {
      breadcrumb = (
        <div className="summary-bar-breadcrumb">
          <Breadcrumb {...breadcrumbsGeneralConfigs} />
        </div>
      );
    } else {
      breadcrumb = (
        <SummaryBarBreadcrumb
          {...breadcrumbsProps}
          i18n={i18n}
          summaryBarActivityLogger={summaryBarActivityLogger}
          scope={scope}
          siteMap={siteMap}
        />);
    }

    let summaryBar = null;
    if (summaryBarItems.length > 0) {
      summaryBar = (
        <Fragment>
          <div className="summary-bar-divider" />
          <SummaryBarItemsResizeGroup {...summaryBarProps} />
        </Fragment>
      );
    }

    return (
      <SummaryBarContainer
        texts={{
          ariaLabel: i18n.getString(_TL_('Summary bar')),
        }}
        backButtonProps={backButtonProps}
        breadcrumb={hideBreadcrumb ? null : breadcrumb}
        summaryBar={summaryBar}
        showScopeBackButton={isNavigationRefreshOn(permissions)}
        i18n={i18n}
      />
    );
  }
}

SummaryBarFactory.propTypes = {
  backButtonProps: PropTypes.shape({
    url: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  }),
  breadcrumbsProps: PropTypes.shape({
    campaignId: PropTypes.number,
    campaignName: PropTypes.string,
    adgroupId: PropTypes.number,
    adgroupName: PropTypes.string,
    campaignType: PropTypes.oneOf(values(CampaignType)),
  }),
  // eslint-disable-next-line react/forbid-prop-types
  breadcrumbsGeneralConfigs: PropTypes.object,
  summaryBarItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    className: PropTypes.string,
    text: PropTypes.string,
    canEdit: PropTypes.bool,
    renderContent: PropTypes.func,
    onClick: PropTypes.func,
  })),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  isAccountsSummary: PropTypes.bool,
  summaryBarActivityLogger: PropTypes.shape({
    changeScopeActivity: PropTypes.any,
  }),
  hideBreadcrumb: PropTypes.bool,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

SummaryBarFactory.defaultProps = {
  summaryBarItems: [],
  breadcrumbsProps: {},
  breadcrumbsGeneralConfigs: null,
  backButtonProps: null,
  isAccountsSummary: false,
  summaryBarActivityLogger: null,
  hideBreadcrumb: false,
};

const wrapped = withPermissions(SummaryBarFactory);

export { wrapped as SummaryBarFactory };
